import { Component, Inject } from '@angular/core';
import { EGI_APP_QUERIES, EgiAppQueries } from '@/app/platform/platform-data/queries/types';
import { FaultyClickTroughConfiguration } from '@/app/platform/platform-data/synchronizers/types';
import { ErrorInformation } from '@shared/models/error/error-information';
import { EGI_APP_ACTIONS, EgiAppActions } from '@/app/platform/platform-data/actions/types';

@Component({
    selector: 'synchronize-app-navigation-items-button',
    templateUrl: './synchronize-app-navigation-items-button.component.html',
    styleUrls: ['./synchronize-app-navigation-items-button.component.css'],
    standalone: false
})
export class SynchronizeAppNavigationItemsButtonComponent {
  constructor(
    @Inject(EGI_APP_ACTIONS)
    private readonly egiAppsSynchronizer: EgiAppActions,
    @Inject(EGI_APP_QUERIES)
    readonly egiAppQueries: EgiAppQueries
  ) {}

  loading = false;
  faultyConfiguredClickTroughPages: FaultyClickTroughConfiguration[] = [];
  showErrorDialog = false;

  async onClick() {
    this.loading = true;
    const result = await this.egiAppsSynchronizer.synchronizeAll();
    this.loading = false;

    result.ifError(errors => {
      this.faultyConfiguredClickTroughPages = [];
      errors.forEach(error => {
        if (this.isFaultyConfigurationError(error)) {
          this.faultyConfiguredClickTroughPages.push(...error.additionalInfo);
          this.openErrorDialog();
        }
      });
    });
  }

  // https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
  private isFaultyConfigurationError(
    error: ErrorInformation | ErrorInformation<FaultyClickTroughConfiguration[]>
  ): error is ErrorInformation<FaultyClickTroughConfiguration[]> {
    return typeof error.additionalInfo !== 'string';
  }

  openErrorDialog(): void {
    this.showErrorDialog = true;
  }

  closeDialog() {
    this.showErrorDialog = false;
  }
}
